import { getEnv } from "./utils/env";
import { Farm, Network, SolanaNetwork } from "./interfaces/network";
import { Pair } from "./interfaces/token";
import {
  farmToken,
  newFarmToken,
  // farmTokenETH,
  pairs,
  newPairs,
  newPairOmniRewards,
  // pairsETH,
  // tokenETH,
} from "./token-config";

// Farms configuration
const bscFarms: Farm[] = [
  {
    contractAddress: getEnv("REACT_APP_FARM_CONTRACT_ADDRESS"),
    rewardToken: farmToken.EVRY_TOKEN,
    pairs: pairs.filter((pair: Pair) =>
      getEnv("REACT_APP_ENABLE_FEATURE_VELO") === "false"
        ? pair.id !== "VELO_TOKEN"
        : pair.id
    ),
    tokens: farmToken,
    ABIName: "Farms",
  },
  {
    contractAddress: getEnv("REACT_APP_COMMON_FARM_CONTRACT_ADDRESS"),
    rewardToken: newFarmToken.VELO_TOKEN,
    pairs: newPairs,
    tokens: newFarmToken,
  },
  {
    contractAddress: getEnv("REACT_APP_OMNI_FARM_CONTRACT_ADDRESS"),
    rewardToken: newFarmToken.OMNI_TOKEN,
    pairs: newPairOmniRewards,
    tokens: newFarmToken,
  },
];

// Mainnet and Testnet Networks
const networksMainnet: Record<number, Network> = {
  56: {
    id: 1,
    name: "BSC Mainnet",
    chainId: 56,
    image: require("/src/assets/icons/network/bsc.svg").default,
    code: "BNB",
    display: "BNB",
    rpcUrls: [
      "https://bsc-dataseed.bnbchain.org",
      "https://bsc-dataseed.nariox.org",
      "https://bsc-dataseed.defibit.io",
      "https://bsc-dataseed.ninicoin.io",
      "https://bsc.nodereal.io",
      "https://bsc-dataseed-public.bnbchain.org",
      "https://bnb.rpc.subquery.network/public",
    ],
    chainExplorerURL: "https://bscscan.com/",
    farm: bscFarms,
    providers: [
      {
        name: "Universe Wallet",
        image: require("/src/assets/icons/provider/universe.svg").default,
      },
      {
        name: "Metamask",
        image: require("/src/assets/icons/provider/metamask.svg").default,
      },
      {
        name: "OKX Wallet",
        image: require("/src/assets/icons/provider/okx.svg").default,
      },
      {
        name: "Bitget Wallet",
        image: require("/src/assets/icons/provider/bitgetWallet.svg").default,
      },
      {
        name: "Coinbase",
        image: require("/src/assets/icons/provider/coinbase.svg").default,
      },
      {
        name: "WalletConnect",
        image: require("/src/assets/icons/provider/walletconnect.svg").default,
      },
      {
        name: "GateWallet",
        image: require("/src/assets/icons/provider/gate.svg").default,
      },
      {
        name: "Coin98",
        image: require("/src/assets/icons/provider/coin98.svg").default,
      },
      {
        name: "SafePal",
        image: require("/src/assets/icons/provider/safepal.svg").default,
      },
      {
        name: "Binance Wallet",
        image: require("/src/assets/icons/provider/binanceWallet.svg").default,
      },
    ],
  },
};

const networksTestnet: Record<number, Network> = {
  97: {
    id: 0,
    name: "BSC Testnet",
    chainId: 97,
    image: require("/src/assets/icons/network/bsc.svg").default,
    code: "BNB",
    display: "BNB",
    rpcUrls: [
      "https://bsc-testnet-dataseed.bnbchain.org",
      "https://bsc-testnet.bnbchain.org",
      "https://bsc-prebsc-dataseed.bnbchain.org",
    ],
    chainExplorerURL: "https://testnet.bscscan.com/",
    farm: bscFarms,
    providers: [
      {
        name: "Universe Wallet",
        image: require("/src/assets/icons/provider/universe.svg").default,
      },
      {
        name: "Metamask",
        image: require("/src/assets/icons/provider/metamask.svg").default,
      },
      {
        name: "OKX Wallet",
        image: require("/src/assets/icons/provider/okx.svg").default,
      },
      {
        name: "Bitget Wallet",
        image: require("/src/assets/icons/provider/bitgetWallet.svg").default,
      },
      {
        name: "Coinbase",
        image: require("/src/assets/icons/provider/coinbase.svg").default,
      },
      {
        name: "WalletConnect",
        image: require("/src/assets/icons/provider/walletconnect.svg").default,
      },
      {
        name: "GateWallet",
        image: require("/src/assets/icons/provider/gate.svg").default,
      },
      {
        name: "Coin98",
        image: require("/src/assets/icons/provider/coin98.svg").default,
      },
      {
        name: "SafePal",
        image: require("/src/assets/icons/provider/safepal.svg").default,
      },
      {
        name: "Binance Wallet",
        image: require("/src/assets/icons/provider/binanceWallet.svg").default,
      },
    ],
  },
};

// Solana networks configuration
const networkSolMainnet: SolanaNetwork = {
  name: "Solana",
  chainId: "mainnet",
  image: require("/src/assets/icons/network/sol.svg").default,
  code: "SOL",
  display: "Solana",
  chainExplorerURL: "https://solscan.io/",
  providers: [
    {
      name: "Phantom",
      image: "/src/assets/icons/provider/phantom.svg",
    },
  ],
};

const networkSolDevnet: SolanaNetwork = {
  name: "Solana Devnet",
  chainId: "devnet",
  image: require("/src/assets/icons/network/sol.svg").default,
  code: "SOL",
  display: "Solana",
  chainExplorerURL: "https://solscan.io/",
  providers: [
    {
      name: "Phantom",
      image: "/src/assets/icons/provider/phantom.svg",
    },
  ],
};

// Environment-based network configurations
const networks =
  getEnv("REACT_APP_IS_PROD")?.toUpperCase() === "TRUE"
    ? networksMainnet
    : networksTestnet;
const networkSol =
  getEnv("REACT_APP_IS_PROD")?.toUpperCase() === "TRUE"
    ? networkSolMainnet
    : networkSolDevnet;

export { networks, networkSol };
